import { createFcmDetails } from '../shared/factory';

export const FCM_DETAILS_SUBSCRIPTION_CONFIGURATION = createFcmDetails('subscription_configuration', {
	owner: 'Membership Squad',
	context: 'Subscription',
	description: `Country specific subscription configuration data to replace subscriptionCountries.json in fe-config

	{
		amounts: [300, 500, 1000, 2000],
		minAmount: 300,
		maxAmount: 20000,
		defaultAmount: 500,
		thirdPartySubscriptionService: '', // optional
		subscriptionCancellationSurveyId: '', // optional
		disableFeedbackForm: false // optional
	}
	`,
	template: {
		amounts: [300, 500, 1000, 2000],
		minAmount: 300,
		maxAmount: 20000,
		defaultAmount: 500,
		thirdPartySubscriptionService: '',
		subscriptionCancellationSurveyId: '',
		disableFeedbackForm: false,
	},
	import: false,
});
